import {i18n} from '~/i18n';

export const sizeOptions = [
  {
    text: i18n('toolbar.size-options.s'),
    value: 's',
    size: 0.8,
  },
  {
    text: i18n('toolbar.size-options.m'),
    value: 'm',
    name: 'bread',
    size: 1,
  },
  {
    text: i18n('toolbar.size-options.l'),
    value: 'l',
    name: 'H3',
    size: 1.25,
  },
  {
    text: i18n('toolbar.size-options.xl'),
    value: 'xl',
    name: 'H2',
    size: 1.5,
  },
  {
    text: i18n('toolbar.size-options.xxl'),
    value: 'xxl',
    name: 'H1',
    size: 2.2,
  },
  {
    text: i18n('toolbar.size-options.xxxl'),
    value: 'xxxl',
    name: 'H1',
    size: 3,
  },
  {
    text: i18n('toolbar.size-options.xxxxl'),
    value: 'xxxxl',
    name: 'H1',
    size: 4,
  },

];

// Get the index of m, l, xl etc. Returns input if no match.
export const getSizeIndex = size => {
  const index = sizeOptions.findIndex(({value}) => value === size);

  if (index !== -1) {
    return index;
  }

  return size;
};

// Get the size value for m, l, xl etc
export const getSizeValue = size =>
  (sizeOptions.find(({value}) => value === size) ?? sizeOptions[1])?.size;

export const fontSizes = {
  s: '0.8em',
  m: '1em',
  l: '1.5em',
  xl: '2em',
  xxl: '3em',
};
